// Common Keys
const HOME = 'Home';
const FOOTER = 'Footer';

const RECORDS_AWARDS_INDEX = 'RecordsAwardsIndex';
const INFORMATION_INDEX = 'InformationIndex';
const HISTORICAL_INDEX = 'HistoricalIndex';
const PLAYOFFS_INDEX = 'PlayoffsIndex';
const OFFICIALS_INDEX = 'OfficialsIndex';
const HALL_OF_FAME_INDEX = 'HallOfFameIndex';
const DRAFT_INDEX = 'DraftIndex';
const AWARDS_INDEX = 'AwardsIndex';
const AWARD_FOOTNOTE = 'AwardsFootnote';
const HEAD_COACH = 'HeadCoach';
const RECORDS_INDEX = 'RecordsIndex';
const RECORDS_INDIVIDUAL = 'RecordsIndividual';
const RECORDS_GOALIE = 'RecordsGoalie';
const RECORDS_TEAM = 'RecordsTeam';
const RECORDS_MODERN = 'RecordsModern';
const RECORDS_ALL_STAR = 'RecordsAllStar';
const RECORDS_MILESTONE = 'RecordsMilestone';
const RECORDS_CLUB = 'RecordsClub';
const RECORDS_ROOKIE = 'RecordsRookie';
const RECORDS_COACH = 'RecordsCoach';
const ALL_STAR_SELECTION = 'AllStarSelection';
const NHL_BOARD_OF_GOVERNORS = 'NHLBoardOfGovernors';
const NHL_ORGANIZATION = 'NHLOrganization';
const NHL_AFFILIATES = 'NHLAffiliates';
const NHL_OFFICES = 'NHLOffices';
const NHLPA_OFFICES = 'NHLPAOffices';
const NHL_HISTORY = 'NHLHistory';
const NHL_HISTORY_RULES = 'NHLHistoryRules';
const NHL_ALL_TIME_STANDINGS = 'NHLAllTimeStandings';
const NHL_ALL_TIME_GAME_SEVEN_STANDINGS = 'NHLAllTimeGameSevenStandings';
const NHL_ALL_TIME_OVERTIME_STANDINGS = 'NHLAllTimeOvertimeStandings';
const NHL_ALL_TIME_PLAYOFF_OVERTIME_STANDINGS = 'NHLAllTimePlayoffOvertimeStandings';
const NHL_SEASON_OPENER_STANDINGS = 'NHLSeasonOpenerStandings';
const OUTDOOR_GAME_STANDINGS = 'OutdoorGameStandings';
const GAMES_OUTSIDE_NORTH_AMERICA_STANDINGS = 'GamesOutsideNorthAmericaStandings';
const NHL_EVENTS = 'NHLEvents';
const NHL_ATTENDANCE = 'NHLAttendance';
const STANLEY_CUP_STATS = 'StanleyCupStats';
const STANLEY_CUP_WINNERS = 'StanleyCupWinners';
const PENALTY_SHOTS = 'NHLPenaltyShots';
const PLAYOFF_PENALTY_SHOTS = 'NHLPlayoffPenaltyShots';
const PLAYOFF_STANDINGS = 'PlayoffStandings';
const PLAYOFF_COACH_RECORDS = 'PlayoffCoachRecords';
const PLAYOFF_TEAM_RECORDS = 'PlayoffTeamRecords';
const PLAYOFF_INDIVIDUAL_RECORDS = 'PlayoffIndividualRecords';
const PLAYOFF_GOALTENDER_RECORDS = 'PlayoffGoaltenderRecords';
const PLAYOFF_FORMATS = 'PlayoffFormats';
const YEARLY_PLAYOFF_RESULTS = 'YearlyPlayoffResults';
const ALL_TIME_GAME_7_HISTORY = 'AllTimeGame7History';
const REFEREES = 'Referees';
const LINESPERSON = 'Linesperson';
const ALL_TIME_OFFICIALS = 'AllTimeOfficials';
const HALL_OF_FAME_OFFICES = 'HallOfFameOffices';
const HALL_OF_FAME_INDUCTEES = 'HallOfFameInductees';
const HOCKEY_HALL_OF_FAME = 'HockeyHallOfFame';
const US_HOCKEY_HALL_OF_FAME = 'USHockeyHallOfFame';
const IIHF_HALL_OF_FAME = 'IIHFHallOfFame';
const DRAFT_FIRST_ROUND = 'DraftFirstRound';
const SUPPLEMENTAL_DRAFT = 'SupplementalDraft';
const DRAFT_HISTORY = 'DraftHistory';
const DRAFT_PICKS = 'DraftPicks';
const DRAFT_ANALYSIS = 'DraftAnalysis';
const DRAFT_HOSTS = 'DraftHosts';
const EXPANSION_DRAFT_PICKS = 'ExpansionDraftPicks';
const EXPANSION_DRAFT_RULES = 'ExpansionDraftRules';
const DRAFT_LOTTERY_RESULTS = 'DraftLotteryResults';
const DRAFT_LOTTERY_FORMATS = 'DraftLotteryFormats';
const DRAFT_LOTTERY_ODDS = 'DraftLotteryOdds';
const DRAFT_LOTTERY_ODDS_ALL_TIME = 'DraftLotteryOddsAllTime';
const THOUSAND_POINT_CAREER = '1000PointCareer';
const FIVE_HUNDRED_GOAL_CAREER = '500GoalCareer';
const ONE_HUNDRED_POINT_SEASON = '100PointSeason';
const FIFTY_GOAL_SEASON = '50GoalSeason';
const FIVE_GOAL_GAME = '5GoalGame';
const THREE_STARS_SELECTION = 'ThreeStarsSelection';
const ALL_STAR_INDEX = 'AllStarIndex';
const EVENTS_INDEX = 'EventsIndex';
const ALMANAC_INDEX = 'AlmanacIndex';
const ALL_STAR_GAMES = 'AllStarGames';
const OUTDOOR_GAMES = 'OutdoorGames';
const OUTDOOR_SKATER_RECORDS = 'OutdoorSkaterRecords';
const OUTDOOR_GOALTENDER_RECORDS = 'OutdoorGoaltenderRecords';
const OUTDOOR_TEAM_RECORDS = 'OutdoorTeamRecords';
const GAMES_OUTSIDE_NORTH_AMERICA = 'GamesOutsideNorthAmerica';
const CHINA_GAMES = 'ChinaGames';
const HOCKEYVILLE = 'Hockeyville';
const INDIVIDUAL_SCORING_RECORDS_HISTORY = 'IndividualScoringRecordsHistory';
const ALL_TIME_RECORD_VS_FRANCHISE_INDEX = 'AllTimeRecordVsFranchise';
const PLAYOFF_SUMMARY_SKATER_STATS = 'PlayoffSummarySkaterStats';
const PLAYOFF_SUMMARY_GOALIE_STATS = 'PlayoffSummaryGoalieStats';
const GAME_WINNING_GOALS_STANLEY_CUP = 'GameWinningGoalsStanleyCup';
const HISTORY_OF_THE_TROPHY = 'HistoryOfTheTrophy';
const NHL_TRADITIONS = 'NHLTraditions';
const DID_YOU_KNOW = 'DidYouKnow';
const GENERAL_MANAGER_REGISTRY = 'GeneralManagerRegistry';
const PLAYOFF_GENERAL_MANAGER_REGISTRY = 'PlayoffGeneralManagerRegistry';
const GENERAL_MANAGER_RECORDS = 'GeneralManagerRecords';
const PLAYOFF_GENERAL_MANAGER_RECORDS = 'PlayoffGeneralManagerRecords';
const PRESEASON_GAMES_OUTSIDE_NORTH_AMERICA = 'PreseasonGamesOutsideNorthAmerica';
const OFFSEASON_GAMES_OUTSIDE_NORTH_AMERICA = 'OffseasonGamesOutsideNorthAmerica';
const SCF_TEAM_RECORDS = 'ScfTeamRecords';
const SCF_SKATER_RECORDS = 'ScfSkaterRecords';
const SCF_GOALIE_RECORDS = 'ScfGoalieRecords';
const SCF_STANDINGS = 'ScfStandings';

const INTERNATIONAL_TOURNAMENTS = 'InternationalTournaments';
const INTERNATIONAL_OVERVIEW_WINNERS = 'InternationalOverviewWinners';
const INTERNATIONAL_OVERVIEW_CLINCHING_GOALS = 'InternationalOverviewClinchingGoals';
const INTERNATIONAL_OVERVIEW_HISTORY_TOURNAMENT_TIDBITS = 'InternationalOverviewHistoryTournamentTidbits';
const INTERNATIONAL_OVERVIEW_DID_YOU_KNOW = 'InternationalOverviewDidYouKnow';
const INTERNATIONAL_TOURNAMENTS_RECAP_CHAMPION = 'InternationalTournamentsRecapChampion';
const INTERNATIONAL_TOURNAMENTS_RECAP_MVP = 'InternationalTournamentsRecapMVP';
const INTERNATIONAL_TOURNAMENTS_RECAP_FORMAT_RESULTS = 'InternationalTournamentsRecapFormatAndResults';
const INTERNATIONAL_TOURNAMENTS_RECAP_GOALIE_STATS = 'InternationalTournamentsRecapGoalieStats';
const INTERNATIONAL_TOURNAMENTS_RECAP_SKATER_STATS = 'InternationalTournamentsRecapSkaterStats';
const INTERNATIONAL_TOURNAMENTS_RECAP_TEAM_STATS = 'InternationalTournamentsRecapTeamStats';
const INTERNATIONAL_TOURNAMENTS_RECAP_ROSTERS = 'InternationalTournamentsRecapRosters';
const INTERNATIONAL_SKATER_RECORDS = 'InternationalSkaterRecords';
const INTERNATIONAL_GOALTENDER_RECORDS = 'InternationalGoaltenderRecords';
const INTERNATIONAL_TEAM_RECORDS = 'InternationalTeamRecords';
const INTERNATIONAL_SKATER_REGISTER = 'InternationalSkaterRegister';
const INTERNATIONAL_GOALTENDER_REGISTER = 'InternationalGoaltenderRegister';

const INDIVIDUAL_SCORING_GOALS = 'IndividualScoringGoals';
const INDIVIDUAL_SCORING_ASSISTS = 'IndividualScoringAssists';
const INDIVIDUAL_SCORING_POINTS = 'IndividualScoringPoints';
const INDIVIDUAL_SCORING_WINS = 'IndividualScoringWins';
const INDIVIDUAL_SCORING_SHUTOUTS = 'IndividualScoringShutouts';

const COMBINE_BENCH_PRESS = 'CombineBenchPress';
const COMBINE_PULL_UPS = 'CombinePullUps';
const COMBINE_HORIZONTAL_JUMP = 'CombineHorizontalJump';
const COMBINE_VERTICAL_JUMP = 'CombineVerticalJump';
const COMBINE_PRO_AGILITY_TEST = 'CombineProAgilityTest';
const COMBINE_GRIP_STRENGTH = 'CombineGripStrength';
const COMBINE_WINGATE_CYCLE = 'CombineWingateCycle';
const COMBINE_VO2_MAX = 'CombineVO2Max';

export default {
    HOME,
    FOOTER,
    RECORDS_AWARDS_INDEX,
    INFORMATION_INDEX,
    HISTORICAL_INDEX,
    PLAYOFFS_INDEX,
    OFFICIALS_INDEX,
    HALL_OF_FAME_INDEX,
    DRAFT_INDEX,
    AWARDS_INDEX,
    AWARD_FOOTNOTE,
    HEAD_COACH,
    RECORDS_INDEX,
    RECORDS_INDIVIDUAL,
    RECORDS_GOALIE,
    RECORDS_TEAM,
    RECORDS_MODERN,
    RECORDS_ALL_STAR,
    RECORDS_MILESTONE,
    RECORDS_CLUB,
    RECORDS_ROOKIE,
    RECORDS_COACH,
    ALL_STAR_SELECTION,
    NHL_BOARD_OF_GOVERNORS,
    NHL_ORGANIZATION,
    NHL_AFFILIATES,
    NHL_OFFICES,
    NHLPA_OFFICES,
    NHL_HISTORY,
    NHL_HISTORY_RULES,
    NHL_ALL_TIME_STANDINGS,
    NHL_ALL_TIME_GAME_SEVEN_STANDINGS,
    NHL_ALL_TIME_OVERTIME_STANDINGS,
    NHL_ALL_TIME_PLAYOFF_OVERTIME_STANDINGS,
    NHL_SEASON_OPENER_STANDINGS,
    OUTDOOR_GAME_STANDINGS,
    GAMES_OUTSIDE_NORTH_AMERICA_STANDINGS,
    NHL_EVENTS,
    NHL_ATTENDANCE,
    STANLEY_CUP_STATS,
    STANLEY_CUP_WINNERS,
    PENALTY_SHOTS,
    PLAYOFF_PENALTY_SHOTS,
    PLAYOFF_STANDINGS,
    PLAYOFF_COACH_RECORDS,
    PLAYOFF_TEAM_RECORDS,
    PLAYOFF_INDIVIDUAL_RECORDS,
    PLAYOFF_GOALTENDER_RECORDS,
    PLAYOFF_FORMATS,
    YEARLY_PLAYOFF_RESULTS,
    ALL_TIME_GAME_7_HISTORY,
    REFEREES,
    LINESPERSON,
    ALL_TIME_OFFICIALS,
    HALL_OF_FAME_OFFICES,
    HALL_OF_FAME_INDUCTEES,
    HOCKEY_HALL_OF_FAME,
    US_HOCKEY_HALL_OF_FAME,
    IIHF_HALL_OF_FAME,
    DRAFT_FIRST_ROUND,
    SUPPLEMENTAL_DRAFT,
    DRAFT_HISTORY,
    DRAFT_PICKS,
    DRAFT_ANALYSIS,
    DRAFT_HOSTS,
    EXPANSION_DRAFT_PICKS,
    EXPANSION_DRAFT_RULES,
    DRAFT_LOTTERY_RESULTS,
    DRAFT_LOTTERY_FORMATS,
    DRAFT_LOTTERY_ODDS,
    DRAFT_LOTTERY_ODDS_ALL_TIME,
    THOUSAND_POINT_CAREER,
    FIVE_HUNDRED_GOAL_CAREER,
    ONE_HUNDRED_POINT_SEASON,
    FIFTY_GOAL_SEASON,
    FIVE_GOAL_GAME,
    THREE_STARS_SELECTION,
    ALL_STAR_INDEX,
    EVENTS_INDEX,
    ALMANAC_INDEX,
    ALL_STAR_GAMES,
    OUTDOOR_GAMES,
    OUTDOOR_SKATER_RECORDS,
    OUTDOOR_GOALTENDER_RECORDS,
    OUTDOOR_TEAM_RECORDS,
    GAMES_OUTSIDE_NORTH_AMERICA,
    CHINA_GAMES,
    HOCKEYVILLE,
    INDIVIDUAL_SCORING_RECORDS_HISTORY,
    ALL_TIME_RECORD_VS_FRANCHISE_INDEX,
    PLAYOFF_SUMMARY_SKATER_STATS,
    PLAYOFF_SUMMARY_GOALIE_STATS,
    GAME_WINNING_GOALS_STANLEY_CUP,
    HISTORY_OF_THE_TROPHY,
    NHL_TRADITIONS,
    DID_YOU_KNOW,
    GENERAL_MANAGER_REGISTRY,
    PLAYOFF_GENERAL_MANAGER_REGISTRY,
    GENERAL_MANAGER_RECORDS,
    PLAYOFF_GENERAL_MANAGER_RECORDS,
    PRESEASON_GAMES_OUTSIDE_NORTH_AMERICA,
    OFFSEASON_GAMES_OUTSIDE_NORTH_AMERICA,
    SCF_TEAM_RECORDS,
    SCF_SKATER_RECORDS,
    SCF_GOALIE_RECORDS,
    SCF_STANDINGS,
    INTERNATIONAL_TOURNAMENTS,
    INTERNATIONAL_OVERVIEW_WINNERS,
    INTERNATIONAL_OVERVIEW_CLINCHING_GOALS,
    INTERNATIONAL_OVERVIEW_HISTORY_TOURNAMENT_TIDBITS,
    INTERNATIONAL_OVERVIEW_DID_YOU_KNOW,
    INTERNATIONAL_TOURNAMENTS_RECAP_CHAMPION,
    INTERNATIONAL_TOURNAMENTS_RECAP_MVP,
    INTERNATIONAL_TOURNAMENTS_RECAP_FORMAT_RESULTS,
    INTERNATIONAL_TOURNAMENTS_RECAP_SKATER_STATS,
    INTERNATIONAL_TOURNAMENTS_RECAP_GOALIE_STATS,
    INTERNATIONAL_TOURNAMENTS_RECAP_ROSTERS,
    INTERNATIONAL_SKATER_RECORDS,
    INTERNATIONAL_GOALTENDER_RECORDS,
    INTERNATIONAL_TEAM_RECORDS,
    INTERNATIONAL_SKATER_REGISTER,
    INTERNATIONAL_GOALTENDER_REGISTER,
    INTERNATIONAL_TOURNAMENTS_RECAP_TEAM_STATS,
    INDIVIDUAL_SCORING_GOALS,
    INDIVIDUAL_SCORING_ASSISTS,
    INDIVIDUAL_SCORING_POINTS,
    INDIVIDUAL_SCORING_WINS,
    INDIVIDUAL_SCORING_SHUTOUTS,
    COMBINE_BENCH_PRESS,
    COMBINE_PULL_UPS,
    COMBINE_HORIZONTAL_JUMP,
    COMBINE_VERTICAL_JUMP,
    COMBINE_PRO_AGILITY_TEST,
    COMBINE_GRIP_STRENGTH,
    COMBINE_WINGATE_CYCLE,
    COMBINE_VO2_MAX,
};
